var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "page-contact" }, [
    _c(
      "section",
      [
        _c("v-content-section", {
          attrs: { content: _vm.content, variant: "black" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-contact__items" },
          [
            _c(
              "v-row",
              {
                staticClass: "page-contact__row",
                attrs: {
                  horizontal: "start",
                  variant: "flex",
                  vertical: "stretch"
                }
              },
              _vm._l(_vm.contacts, function(contact) {
                return _c(
                  "v-column",
                  {
                    key: "contact-item-id-" + contact.id,
                    staticClass: "page-contact__column",
                    attrs: { large: 4 }
                  },
                  [
                    _c("v-contact-box", {
                      staticClass: "page-contact__item",
                      attrs: { data: contact }
                    })
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }